// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/service/v2/bianka.proto" (package "bianka.service.v2", syntax proto3)
// tslint:disable
import { ReportBusinessResponse } from "./responses";
import { BusinessEvent } from "../../core/api/v2/business";
import { ReportActivitiesResponse } from "./responses";
import { ReportActivitiesRequest } from "./requests";
import { ReportActivityResponse } from "./responses";
import { ActivityEvent } from "../../core/api/v2/activity";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service bianka.service.v2.BiankaService
 */
export const BiankaService = new ServiceType("bianka.service.v2.BiankaService", [
    { name: "ReportActivity", options: {}, I: ActivityEvent, O: ReportActivityResponse },
    { name: "ReportActivities", options: {}, I: ReportActivitiesRequest, O: ReportActivitiesResponse },
    { name: "ReportBusiness", options: {}, I: BusinessEvent, O: ReportBusinessResponse }
]);
